
<template>
  <div class="form__lang">
    <a @click.prevent="onSwitchClick('en')">English</a> | <a @click.prevent="onSwitchClick('de')">Deutsch</a>
  </div>
</template>

<script>
import instanceConfig from '../utils/instanceConfig';
export default {
  props: ['headerLangSelector'],
  methods: {
    onSwitchClick: function (lang) {
      instanceConfig.setCurrentLang(lang);
      this.$root.$forceUpdate();
      this.$root.$emit('rerender');
      this.$router.push({ path: 'reload' });
    },
  }
};

</script>



// WEBPACK FOOTER //
// src/layout/HeaderLangSelector.vue